module.exports = new __parcel__URL__("blindinglight.3d35e55a.png").toString();